<script>
export default {
  props: {
    id: {
      type: [String, Number, undefined],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      crudeForm: {
        nameFa: "",
        nameEn: "",
      },
      form: this.crudeForm,
      rerenderComponent: false,
    };
  },
  computed: {
    isEditing() {
      return this.id != null && this.id != undefined;
    },
  },
  watch: {
    "$route.fullPath": {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.resetForm();
      },
    },
  },
  mounted() {
    if (this.id != null) {
      this.fetchRecord();
    }
  },
  methods: {
    fetchRecord() {
      this.$axios.get(`mobile-brands/${this.id}`).then((res) => {
        this.form = { ...this.form, ...res.data };
        this.rerenderComponent = true;
      });
    },
    submitForm() {
      const data = JSON.parse(JSON.stringify(this.form));

      if (this.isEditing) {
        this.updateRecord(data);
      } else {
        this.createRecord(data);
      }
    },
    createRecord(data) {
      this.$axios.post("mobile-brands", data).then((res) => {
        this.$swal("موفق!", "برند با موفقیت به ثبت شد", "success");
        this.$store.dispatch("tables/addNewItem", {
          key: "mobile_brand",
          item: res.data,
        });
      });
    },
    updateRecord(data) {
      this.$axios.put(`mobile-brands/${this.id}`, data).then((res) => {
        this.$swal("موفق!", "برند با موفقیت به روزرسانی شد", "success");
        this.$store.dispatch("tables/updateItem", {
          key: "mobile_brand",
          item: res.data,
        });
      });
    },
    resetForm() {
      this.rerenderComponent = false;
      const app = this;
      this.$nextTick(function() {
        app.form = app.crudeForm;
        app.rerenderComponent = true;
      });
    },
  },
};
</script>

<template>
  <div v-if="rerenderComponent">
    <div class="row mx-auto">
      <div class="col-12 px-0">
        <div class="card">
          <div class="card-body">
            <ValidationObserver v-slot="{ handleSubmit }" tag="div">
              <form
                class="needs-validation mt-4"
                @submit.prevent="handleSubmit(submitForm)"
              >
                <div class="row">
                  <div class="col-md-6">
                    <validation-input
                      v-model="form.nameFa"
                      type="text"
                      placeholder="نام فارسی"
                      rules="required|min:3"
                      validation-field-name="نام فارسی"
                      label="نام فارسی"
                    ></validation-input>
                  </div>
                  <div class="col-md-6">
                    <validation-input
                      v-model="form.nameEn"
                      type="text"
                      placeholder="نام انگلیسی"
                      rules="required|min:3"
                      validation-field-name="نام انگلیسی"
                      label="نام انگلیسی"
                    ></validation-input>
                  </div>
                </div>
                <button
                  class="btn btn-primary mt-4"
                  style="float: left"
                  type="submit"
                >
                  {{ isEditing ? "ویرایش برند" : "ثبت برند" }}
                </button>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
